import { HTMLAttributes, memo } from 'react';
import styles from './Form.module.css';
import { FieldsBlock } from './components/FieldsBlock';
import { FieldsRow } from './components/FieldsRow';

const FormComponent =
  /**
   * Renders a form container with optional children and extended components.
   * Accepts standard HTML `form` attributes via `htmlAttributes`.
   * @param props - Component props.
   * @param props.children - Optional React nodes to be rendered inside the form.
   * @param props.htmlAttributes - Additional HTML attributes for the `form` element.
   * @returns Form component with attached subcomponents: FieldsBlock and FieldsRow.
   */
  memo(({ children, ...htmlAttributes }: HTMLAttributes<HTMLFormElement>) => {
    return (
      <form {...htmlAttributes} className={styles.form}>
        {children}
      </form>
    );
  });

FormComponent.displayName = 'Form';

export const Form =
  /**
   * Enhanced Form component with subcomponents for structuring form content.
   */
  Object.assign(FormComponent, {
    FieldsBlock,
    FieldsRow,
  });
